import { normKey } from './normKey';

// Końcówki fleksyjne po usunięciu polskich znaków („-ów” → „-ow”, „-ę” → „-e”), najdłuższe najpierw.
const ENDINGS = ['ami', 'ach', 'iem', 'ow', 'om', 'em', 'y', 'i', 'e', 'a', 'o', 'u'];
const MIN_STEM = 3;

/** Lekki stemmer dla znormalizowanego słowa (bez polskich znaków). */
export function stem(word: string): string {
  const ending = ENDINGS.find((e) => word.endsWith(e) && word.length - e.length >= MIN_STEM);
  if (ending !== undefined) return word.slice(0, -ending.length);
  // Ruchome „e” w formie bez końcówki: „jajek” → „jajk” jak „jajka” → „jajk”.
  // Nie obcinamy samego „k”, bo „wódka” ≠ „woda”.
  return word.endsWith('ek') && word.length - 1 >= MIN_STEM ? `${word.slice(0, -2)}k` : word;
}

/** Podobieństwo 0..1 nazw (liczone na ich normKey). */
export function similarity(a: string, b: string): number {
  return keySimilarity(normKey(a), normKey(b));
}

/** Podobieństwo 0..1 dwóch gotowych kluczy: max(Dice na trigramach, Jaccard na rdzeniach słów). */
export function keySimilarity(a: string, b: string): number {
  if (a === '' || b === '') return 0;
  if (a === b) return 1;
  return Math.max(trigramDice(a, b), stemJaccard(a, b));
}

export function tokens(key: string): string[] {
  return key.split(' ').filter((t) => t !== '');
}

function trigramDice(a: string, b: string): number {
  const ta = trigrams(a);
  const tb = trigrams(b);
  let common = 0;
  let total = 0;
  for (const [gram, count] of ta) {
    common += Math.min(count, tb.get(gram) ?? 0);
    total += count;
  }
  for (const count of tb.values()) total += count;
  return total === 0 ? 0 : (2 * common) / total;
}

function trigrams(key: string): Map<string, number> {
  const padded = ` ${key} `;
  const grams = new Map<string, number>();
  for (let i = 0; i + 3 <= padded.length; i++) {
    const gram = padded.slice(i, i + 3);
    grams.set(gram, (grams.get(gram) ?? 0) + 1);
  }
  return grams;
}

function stemJaccard(a: string, b: string): number {
  const sa = new Set(tokens(a).map(stem));
  const sb = new Set(tokens(b).map(stem));
  let common = 0;
  for (const s of sa) if (sb.has(s)) common++;
  const union = sa.size + sb.size - common;
  return union === 0 ? 0 : common / union;
}
